export const searchCategories = {
  COUNTRY: 'country',
  INDUSTRY: 'industry',
  QUERY: 'query',
};
